"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const ro = require("redux-observable");
const ytj_1 = require("./ytj");
const region_1 = require("./region");
const list_1 = require("./list");
const salesman_1 = require("./salesman");
const members_1 = require("./members");
const userGroups = require("./userGroups");
const wizard_1 = require("./wizard");
const _dashboard = require("../../modules/dashboard/epics");
const _usergroupListEpics = require("../../modules/usergroup/list/epics");
const _usergroupInviteEpics = require("../../modules/usergroup/invite/epics");
const dashboard = _dashboard.default('customer');
const usergroupListMembers = _usergroupListEpics.default('customer/members');
const usergroupListUserGroups = _usergroupListEpics.default('customer/user-groups');
const usergroupInviteMembers = _usergroupInviteEpics.default('customer/members');
const usergroupInviteUserGroups = _usergroupInviteEpics.default('customer/user-groups');
exports.allEpics = ro.combineEpics(list_1.fetchAdminCustomerList, ytj_1.searchYtjCompany, ytj_1.getYtjCompany, region_1.getAllRegions, salesman_1.getAllSalesmans, members_1.moveUsersToGroup, userGroups.handleCreateAndUpdateUserGroup, userGroups.removeGroup, userGroups.removeUser, userGroups.move, wizard_1.changeStep, wizard_1.getCustomer, wizard_1.getContractFiles, wizard_1.saveStep1, wizard_1.handleCompanyLogo, wizard_1.handleContractFiles, wizard_1.triggerContractFilesFetching, wizard_1.fetchCustomerFeatures, dashboard.create, dashboard.edit, dashboard.fetch, dashboard.remove, usergroupListMembers.fetch, usergroupListUserGroups.fetch, usergroupInviteMembers.invite, usergroupInviteUserGroups.invite);
//# sourceMappingURL=index.js.map